var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M22 2v16h-6l-4 4-4-4H2V2h20zm-8 6h-4v4h4V8z"}));
}

Pin.defaultProps = {"width":"24","height":"24","aria-label":"pin icon","viewBox":"0 0 24 24"};

module.exports = Pin;

Pin.default = Pin;
